import { render } from "./AdminNature.vue?vue&type=template&id=8b2052e2&scoped=true"
import script from "./AdminNature.vue?vue&type=script&lang=js"
export * from "./AdminNature.vue?vue&type=script&lang=js"

import "./AdminNature.vue?vue&type=style&index=0&id=8b2052e2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b2052e2"]])

export default __exports__